module.exports = __webpack_public_path__ + "img/D201507_1.742cfab0.jpg";